export var tableMobileContainerTheme = {
  baseStyle: () => ({
    container: {
      isolation: 'isolate',
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%'
    },
    row: {
      paddingY: 'm',
      backgroundColor: 'neutral.white',
      transition: "background-color 0.1s ease-in-out",
      outlineColor: 'transparent',
      _highlighted: {
        backgroundColor: 'brand.lightest',
        transition: "background-color 0.3s ease-in-out"
      },
      _focusVisible: {
        outlineColor: 'focus.focus',
        outlineOffset: '-2px',
        transition: 'outline-color 0.2s'
      }
    },
    loaderContainer: {
      position: 'absolute',
      backgroundColor: 'neutral.white',
      left: 0,
      height: '50%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 'docked'
    }
  })
};
//# sourceMappingURL=_TableMobileContainer.theme.js.map